<template>
  <div class="w-95 pl-5" ref="panel">
    <div class="row w-100 justify-content-start">
      <div style="width: calc(100vw - 50px);  height: calc(100vh - 20px);"> <!-- border: 1px solid black; -->
        <matrix :groupData="streamings" :panelWidth='panelWidth'></matrix>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Matrix from "../../components/Matrix.vue";
import CONST from '../../utils/const'
import Utils from '../../utils/utils'

export default {
  components: { Matrix },
  data() {
    return {
      scenicAreaId: Utils.getScenicAreaIdFromUrlPath(),
      streamings: [],
      panelWidth: null,
      resizeInterval: null
    };
  },
  watch: {
    '$route'(to, from) {
      this.scenicAreaId = Utils.getScenicAreaIdFromUrlPath()
    },

    scenicAreaId() {
      this.setStreamings()
    },
  },
  methods: {
    async setStreamings() {
      this.streamings = []
      await this.$store.dispatch('scenicArea/getDeviceByScenicAreaId', {id: this.scenicAreaId})
      this.streamings = this.$store.getters['getScenicAreaVideoCamera'].filter(vc => vc.isDisabled === false)
      console.log('streams: ',this.streamings)
      
    },

    handleResize() {
      this.panelWidth = this.$refs.panel.clientWidth
    },
  },
  mounted(){
    this.setStreamings()
    this.resizeInterval = setInterval(async () => {
      this.handleResize();
    }, 1000);
    
  },
  destroyed(){
    if (this.resizeInterval) clearInterval(this.resizeInterval);
    this.resizeInterval = null;
    
  },
};
</script>

